import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import ConfirmationModal from 'garaje/components/ui/classic/confirmation-modal';

interface UiClassicConfirmationModalSignature {
  Args: {
    headerMessage?: string;
    bodyMessage?: string;
    confirmText?: string;
    cancelText?: string;
    confirm: () => unknown;
    cancel: () => unknown;
  };
  Element: HTMLDivElement;
}

export default <template>
  <ConfirmationModal
    @title={{or @headerMessage "Do you want to leave this page?"}}
    @ctaText={{or @confirmText "Continue"}}
    @cancelText={{@cancelText}}
    @onClose={{@cancel}}
    @handleTaskAction={{@confirm}}
  >
    <p class="mt-4">
      {{#if @bodyMessage}}
        {{@bodyMessage}}
      {{else}}
        You will lose any unsaved changes. Are you sure you want to continue?
      {{/if}}
    </p>
  </ConfirmationModal>
</template> satisfies TOC<UiClassicConfirmationModalSignature>;
